import { handleValidateAndDispatchAccount, handleConnectedDepositMode, maybeTriggerSync } from '../submitUtils';

export default async function handleStocksSubmit({ formValues, dispatch, setLoading, category }) {
  const { provider, accountArray } = formValues;
  const accounts = accountArray ? accountArray.filter((a) => a.isImported) : [formValues];

  await Promise.all(
    accounts.map(async (accountData) => {
      const flattened = { ...formValues, ...provider, ...accountData };
      const withConnected = await handleConnectedDepositMode(flattened, { dispatch });
      const { resultDispatch, payload } = await handleValidateAndDispatchAccount({ category, userInput: withConnected, dispatch, setLoading });
      if (resultDispatch?.payload?.accounts?.[0]?.id) {
        maybeTriggerSync({ payload, category, dispatch, accountId: resultDispatch.payload.accounts[0].id });
      }
    }),
  );
}
